module.exports = __webpack_public_path__ + "assets/img/ic-export-p-blue.bb13fdeb.svg";